import { render, staticRenderFns } from "./loginFail.vue?vue&type=template&id=84ecab20&"
import script from "./loginFail.vue?vue&type=script&lang=js&"
export * from "./loginFail.vue?vue&type=script&lang=js&"
import style0 from "./loginFail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports